module.exports = __webpack_public_path__ + "static/bks-iyengar-lotus-820d23384d94c409044731befa0d8907.jpg";